import { html } from 'lit';
import { RefreshCw } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-refresh-cw')
export class PdsIconRefreshCw extends PdsIcon {
  @state()
  icon = RefreshCw;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
